module.exports = __webpack_public_path__ + "static/quicksand-variable-f9baef8ac0d836e6486419e282e42336.ttf";